import React from 'react'
import BasicInformation from './BasicInformation'
import License from './License'
import useFetchData from '../../../../../hooks/useFetchData'
import { useSelector } from 'react-redux'
import Curriculum from './Curriculum'
import ReadOnly from './ReadOnly'
import SchoolLocation from './SchoolLocation'

const General = () => {
  const { isLoading, data: tenant } = useFetchData('tenant')
  const permissions = useSelector((state) => state?.session?.permissions?.tenant || {})
  const permissionsCurriculum = useSelector((state) => state?.session?.permissions?.curriculum)
  return (
    <>
      <BasicInformation permission={permissions['updated']} tenant={tenant || {}} isLoading={isLoading} />
      <SchoolLocation permission={permissions['updated']} tenant={tenant || {}} />
      <License permission={permissions['updated-license']} licenseId={tenant?.licenseId || []} />
      {permissionsCurriculum && (
        <Curriculum
          permission={permissions['updated-curriculum']}
          curriculumId={tenant?.curriculumId || []}
        />
      )}
      {permissions['updated-read-only'] && (
        <ReadOnly data={tenant?.readOnly || {}} permission={permissions['updated-read-only']} />
      )}
    </>
  )
}

export default General
